import * as jsxRuntime from "C:\\Eido-projects\\87-eido-3.0-eco-village\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment